// Coupon utility functions

import { CouponDetail } from '@/src/types/couponTray'

/**
 * Formats coupon messages by replacing <amount> with the actual amount.
 * @param couponDetails Array of coupon detail objects
 * @returns Array of formatted messages
 */
export function formatCouponMessages(
    couponDetails: CouponDetail[],
    formatCurrency: (price: number) => string
): string[] {
    return couponDetails.map(couponDetail => {
        let msg = couponDetail.message || ''
        if (msg.includes('<amount>')) {
            msg = msg.replace('<amount>', String(formatCurrency(couponDetail.amount)))
        }
        return msg
    })
}
